import React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import "./MultipleSelect.css";

const MultipleSelect = ({
  options = [],
  name = "name",
  readOnly = false,
  onChange,
  errors = [],
  formValues,
  label,
  id = "",
  required = false,
  ...props
}) => {
  //methods
  const handleChange = (e) => {
    onChange({
      target: {
        name: name,
        value: e.target.value,
      },
    });
  };

  //builders
  return (
    <div className="multiple-select">
      <FormControl margin="none" style={{ position: "relative" }} fullWidth>
        <div className="label">{`${label} ${required ? "*" : ""}`}</div>
        <Select
          labelId="multiple-checkbox-label"
          id="multiple-checkbox"
          multiple
          margin="dense"
          fullWidth
          value={formValues?.[`${name}`] || []}
          onChange={handleChange}
          input={<OutlinedInput className="mui-outlined-input" />}
          error={errors[`${name}`] ? true : false}
          helperText={errors[`${name}`] ? errors?.[`${name}`]?.[0] : null}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 400,
                width: 250,
              },
            },
          }}
          {...props}
        >
          {options.map((item) => (
            <MenuItem key={item} value={item}>
              <Checkbox
                checked={(formValues?.[`${name}`] || [])?.indexOf(item) > -1}
              />
              <ListItemText primary={item} />
            </MenuItem>
          ))}
        </Select>
        {errors[`${name}`] && (
          <FormHelperText error={true}>{errors[`${name}`]}</FormHelperText>
        )}
      </FormControl>
    </div>
  );
};

export default MultipleSelect;
